import { FileUpload, FileUploadHandlerEvent } from "primereact/fileupload";
import React, { LegacyRef, forwardRef } from "react";
import styled from "styled-components";
import { concatClassnames } from "../../utils/util";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { CvButtonSpinner } from "./CvButtonSpinner";

interface FileUploadBasicProps {
  onFileSelected: (event: FileUploadHandlerEvent) => void;
  loading: boolean;
  label?: string;
  noLabel?: boolean;
  textButton?: boolean;
  outlined?: boolean;
  className?: string;
  newIcon?: string;
  style?: React.CSSProperties;
  multiple?: boolean;
}

export const CvpFileUploadBasic = forwardRef(
  (props: FileUploadBasicProps, ref) => {
    const L = useLocStore(LocContext.GENERAL);
    const {
      label,
      noLabel,
      loading,
      onFileSelected,
      className,
      textButton,
      outlined,
      newIcon,
      style,
      multiple,
    } = props;

    const icon = newIcon ? newIcon : "pi pi-upload";

    return (
      <StyledFileUploadContainer outlined={outlined} textButton={textButton}>
        <FileUpload
          style={style}
          className={concatClassnames([className, noLabel && "no-label"])}
          ref={ref as LegacyRef<FileUpload>}
          mode="basic"
          accept="*/*"
          chooseLabel={label}
          customUpload
          uploadHandler={async (event) => {
            await onFileSelected(event);

            event.options.clear();
          }}
          chooseOptions={{
            icon: !loading ? icon : <CvButtonSpinner className="pi" />,
            className: "upload-button",
          }}
          auto
          multiple={multiple}
        />
      </StyledFileUploadContainer>
    );
  }
);

const StyledFileUploadContainer = styled.div<{
  textButton: boolean;
  outlined: boolean;
}>`
  .upload-button {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-between;
    font-size: 0.85em;
    font-weight: 600;
    border: none;
    padding: 0.6rem 1rem;

    .pi.pi.pi {
      font-size: 0.9em;
      font-weight: 600;
      margin-left: 1rem;
      margin-right: 0;
    }

    ${(props) => {
      if (props.textButton)
        return `
        background-color: transparent;
        color: var(--primary-500);
        `;
    }}

    ${(props) => {
      if (props.outlined)
        return `
        background-color: transparent;
        border: 1px solid var(--primary-500);
        color: var(--primary-500);
        `;
    }}
  }

  .upload-button:hover {
    opacity: 0.7;
    -webkit-transition: all ease-out 0.3s;
    -moz-transition: all ease-out 0.3s;
    -o-transition: all ease-out 0.3s;
    transition: all ease-out 0.3s;

    ${(props) => {
      if (props.textButton)
        return `
        background-color: var(--primary-50);
        opacity: 1;
        `;
    }}
  }

  .upload-button:focus {
    box-shadow: 0 0 0 0.1rem var(--primary-200);
  }

  .no-label {
    .p-button-label {
      display: none;
    }
    .upload-button .pi.pi.pi.pi {
      margin-left: 0;
    }
  }
`;
